import script from "./TokenOwnerList.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenOwnerList.vue?vue&type=script&setup=true&lang=js"

import "./TokenOwnerList.vue?vue&type=style&index=0&id=9f2f4194&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f2f4194"]])

export default __exports__